module.exports = __webpack_public_path__ + "img/networkContracts.c5e709e8.svg";